module.exports = "<s-field type=\"select\" :options=\"options\" v-bind=\"$attrs\" v-if=\"options\" />\n"